class AssortmentParameter {
    constructor() {
        this.product_external_id = ''
        this.product_name = ''
        this.coverage = ''
        this.stack_items = ''
        this.showcase_items = ''
        this.stock_max = ''
        this.edit_item = false
        this.is_restocking_new = ''
    }

    static get fieldNames() {
        return {
            product_external_id: 'ID',
            product_name: 'Produto',
            coverage: 'Tc Ciclo',
            stack_items: 'Qtd. Pilha',
            showcase_items: 'Mostruário',
            stock_max: 'Est. Máx.',
            is_restocking_new: 'Novo em Estoque'
        }
    }

    static get fieldTypes() {
        return {
            product_external_id: 'number',
            product_name: 'text',
            coverage: 'number',
            stack_items: 'number',
            showcase_items: 'number',
            stock_max: 'number',
            edit_item: 'boolean',
            is_restocking_new: 'boolean'
        }
    }

    static get editableFields() {
        return {
            id: true,
            coverage: true,
            stack_items: true,
            showcase_items: true,
            stock_max: true,
            is_restocking_new: false
        }
    }

    static get visibleFields() {
        return {
            product_external_id: true,
            product_name: true,
            coverage: true,
            stack_items: true,
            showcase_items: true,
            stock_max: true,
            is_restocking_new: false
        }
    }

}

export default AssortmentParameter

export { AssortmentParameter }
